var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "tax-configuration-group-sku-modal",
        title: _vm.modalTitle,
        centered: "",
        size: "xl",
        "no-close-on-backdrop": "",
        "hide-footer": "",
      },
      on: { hidden: _vm.cleanState },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _vm.fetching
        ? _c("e-spinner")
        : _c(
            "div",
            [
              _vm.group.ncm
                ? _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-1",
                      attrs: { variant: "info", show: "" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "TAX_CONFIGURATION_GROUP.SKU_ASSOCIATION.NCM_RESTRICTED",
                              { ncm: _vm.group.ncm }
                            )
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "e-filters",
                {
                  attrs: {
                    title: _vm.$t("Filtrar produtos"),
                    "search-text": _vm.$t("Pesquisar e adicionar"),
                    searching: _vm.searching,
                  },
                  on: { search: _vm.searchAndAdd, reset: _vm.resetFilters },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-ean",
                              type: "text",
                              label: _vm.$t("Código de barras"),
                              placeholder: _vm.$t("Código de barras"),
                            },
                            model: {
                              value: _vm.filters.ean,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "ean", $$v)
                              },
                              expression: "filters.ean",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "5" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-name",
                              type: "text",
                              label: _vm.$t("Nome"),
                              placeholder: _vm.$t("Nome"),
                            },
                            model: {
                              value: _vm.filters.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "name", $$v)
                              },
                              expression: "filters.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-ncm",
                              type: "select-searchable",
                              label: _vm.$t("NCM"),
                              placeholder: _vm.$t("Digite para pesquisar"),
                              options: _vm.getComboNcms,
                              disabled: !!_vm.group.ncm,
                            },
                            on: { fetchSearch: _vm.ncmSearch },
                            model: {
                              value: _vm.filters.ncm,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "ncm", $$v)
                              },
                              expression: "filters.ncm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-brand",
                              type: "vue-select",
                              label: _vm.$t("Marca"),
                              placeholder: _vm.$t("Todas"),
                              options: _vm.getComboBrands,
                            },
                            model: {
                              value: _vm.filters.brand,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "brand", $$v)
                              },
                              expression: "filters.brand",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-group",
                              type: "vue-select",
                              label: _vm.$t("Grupo"),
                              placeholder: _vm.$t("Todos"),
                              options: _vm.getComboGroups,
                            },
                            on: { input: _vm.selectGroup },
                            model: {
                              value: _vm.filters.group,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "group", $$v)
                              },
                              expression: "filters.group",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-subgroup",
                              type: "vue-select",
                              label: _vm.$t("Subgrupo"),
                              placeholder: _vm.$t("Todos"),
                              options: _vm.getComboSubgroups,
                              disabled: !_vm.filters.group,
                            },
                            model: {
                              value: _vm.filters.subgroup,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "subgroup", $$v)
                              },
                              expression: "filters.subgroup",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-department",
                              type: "vue-select",
                              label: _vm.$t("Departamento"),
                              placeholder: _vm.$t("Todos"),
                              options: _vm.getComboDepartments,
                            },
                            model: {
                              value: _vm.filters.department,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "department", $$v)
                              },
                              expression: "filters.department",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-line",
                              type: "vue-select",
                              label: _vm.$t("Linha"),
                              placeholder: _vm.$t("Todas"),
                              options: _vm.getComboLines,
                            },
                            model: {
                              value: _vm.filters.line,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "line", $$v)
                              },
                              expression: "filters.line",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-card-actions",
                {
                  attrs: {
                    "no-actions": "",
                    title: _vm.associatedTitle,
                    "show-loading": _vm.saving,
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "mb-1 align-items-end" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "sku-modal-local-search",
                              type: "text",
                              label: _vm.$t("Localizar na lista"),
                              placeholder: _vm.$t("Nome ou código de barras"),
                            },
                            model: {
                              value: _vm.localSearch,
                              callback: function ($$v) {
                                _vm.localSearch = $$v
                              },
                              expression: "localSearch",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-right", attrs: { md: "6" } },
                        [
                          _c("e-page-size-selector", {
                            staticClass: "d-inline-block mr-1",
                            attrs: { "per-page": _vm.localPaging.pageSize },
                            on: { change: _vm.pageSizeChange },
                          }),
                          _vm.notAssociatedSkus.length
                            ? _c("e-button", {
                                staticClass: "mr-1",
                                attrs: {
                                  variant: "outline-warning",
                                  icon: "x-circle",
                                  text: _vm.removeNotAssociatedText,
                                  title: _vm.$t(
                                    "Mantém na lista apenas os produtos já associados a esta exceção"
                                  ),
                                },
                                on: { click: _vm.removeNotAssociated },
                              })
                            : _vm._e(),
                          _vm.selectedSkus.length
                            ? _c("e-button", {
                                attrs: {
                                  variant: "outline-danger",
                                  icon: "trash",
                                  text: _vm.$t("Remover todos"),
                                },
                                on: { click: _vm.removeAll },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-table", {
                    staticClass: "bordered",
                    attrs: {
                      "show-empty": "",
                      responsive: "",
                      striped: "",
                      small: "",
                      "empty-text": _vm.$t(
                        "Nenhum produto associado. Use os filtros acima para pesquisar e adicionar."
                      ),
                      fields: _vm.fields,
                      items: _vm.paginatedSkus,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(action)",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("e-grid-actions", {
                              attrs: {
                                "show-update": false,
                                "show-delete": true,
                              },
                              on: {
                                delete: function ($event) {
                                  return _vm.removeSku(item)
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(taxConfigurationGroupName)",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm.isFromAnotherGroup(item)
                              ? _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: "warning",
                                      title: _vm.$t(
                                        "Ao salvar, o produto passará a usar esta exceção"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.taxConfigurationGroupName) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm.isFromSameGroup(item)
                              ? _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: "success",
                                      title: _vm.$t(
                                        "Já está associado a esta exceção"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Associado")) + " "
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("e-pagination-summary", {
                            attrs: {
                              "current-page": _vm.localPaging.currentPage,
                              "per-page": _vm.localPaging.pageSize,
                              total: _vm.filteredSkus.length,
                              "total-on-page": _vm.paginatedSkus.length,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("b-pagination", {
                            attrs: {
                              align: "right",
                              "total-rows": _vm.filteredSkus.length,
                              "per-page": _vm.localPaging.pageSize,
                            },
                            model: {
                              value: _vm.localPaging.currentPage,
                              callback: function ($$v) {
                                _vm.$set(_vm.localPaging, "currentPage", $$v)
                              },
                              expression: "localPaging.currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", align: "right" } },
                    [
                      _c("e-button", {
                        staticClass: "mr-1",
                        attrs: {
                          variant: "outline-primary",
                          icon: "x-circle",
                          text: _vm.$t("Cancelar"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.showModal = false
                          },
                        },
                      }),
                      _c("e-button", {
                        attrs: {
                          variant: "primary",
                          icon: "save",
                          busy: _vm.saving,
                          text: _vm.$t("Salvar"),
                        },
                        on: { click: _vm.save },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }